.container {
	box-sizing: border-box;
	display: flex;
	padding: 10px;
	border-radius: 5px;
	position: absolute;
	box-shadow: var(--ds-shadow-raised, 0px 1px 5px 0px var(--adg3-color-N40));
	border: 1px solid var(--ds-border, var(--adg3-color-N40));
	flex-direction: column;
	width: 250px;
	height: 50px;
	cursor: pointer;
	background-color: var(--ds-surface, var(--adg3-color-N0));
}

.title {
	line-height: 20px;
	vertical-align: top;
	display: inline-block;
	font-size: 15px;
	font-weight: 600;
	color: var(--ds-text, var(--adg3-color-N700));
	min-width: 0;
}

.avatar {
	display: flex;
	margin-right: 5px;
	align-items: center;
}

.content {
	display: flex;
	align-items: center;
}
